/**
 * URL rules for Settings that outlived the screens they point at.
 *
 * Its own module, with no imports, because these are pure string rules and
 * putting them in Settings.tsx makes them untestable — that file pulls in
 * react-router-dom, which is ESM-only and unresolvable under CRA's jest.
 */

/**
 * Whether a Settings URL is an old link to Deployment Targets, which now live at
 * /deliver.
 *
 * ONLY explicit signals count, and that distinction is the whole function.
 * `targets` was the DEFAULT sub-view, so a bare `?tab=page-generation` used to
 * mean it — but a bare `?tab=page-generation` is also exactly what clicking the
 * Page Generation tab produces. Treating the bare form as legacy makes the tab
 * unreachable: you click it and bounce straight to /deliver.
 *
 * `site`/`plan` count as explicit because nothing except the targets drill-down
 * ever put them in a Settings URL. A bare old bookmark just lands on Page specs,
 * which is a far cheaper wrong answer than a tab nobody can open.
 */
export function isLegacyTargetsLink(
  tab: string | null,
  sub: string | null,
  site: string | null,
  plan: string | null,
): boolean {
  if (tab !== 'page-generation') return false;
  return sub === 'targets' || site !== null || plan !== null;
}
